import React from 'react';
import { Accordion, AccordionItem, Icon } from '@brighterion/br-ui';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import RuleStatementOverview from './RuleStatementOverview';
import styles from './SplitRuleStatement.css';

type Props = {
    expression?: AdvancedRuleExpression;
    ruleInputs: RuleInputs[] | undefined;
    lists: RuleLists[] | undefined;
    parameters: Rule['parameters'];
    outputDescription: string;
    listData?: ListManagementApiList[];
    conclusionValues?: ConclusionValues;
};

const SplitRuleStatement = ({
    outputDescription,
    ruleInputs,
    parameters,
    lists,
    listData,
    expression,
    conclusionValues
}: Props) => {
    const { t } = useTranslation();

    return (
        <Accordion className={styles.accordion} noAutoCollapse>
            <AccordionItem
                name='revision'
                header={({ handleOnClick, handleKeyDown, expanded }) => {
                    return (
                        <div
                            className={clsx(styles.headerContainer, expanded && styles.borderBottom)}
                            tabIndex={0}
                            onClick={handleOnClick}
                            onKeyDown={handleKeyDown}
                            role='button'
                        >
                            <Icon className={styles.icon} size='md' name={expanded ? 'arrow-up-1' : 'arrow-down-1'} />
                            <h4 className={styles.header}>{t('Rule Statement')}</h4>
                        </div>
                    );
                }}
            >
                <RuleStatementOverview
                    outputDescription={outputDescription}
                    ruleInputs={ruleInputs}
                    parameters={parameters}
                    lists={lists!}
                    listData={listData}
                    conclusionValues={conclusionValues}
                    expression={expression}
                />
            </AccordionItem>
        </Accordion>
    );
};

export default React.memo(SplitRuleStatement);
